export const getScrollBottom = (scrollElement: HTMLElement): number => {
  if (typeof window === 'undefined') {
    return 0;
  }

  return scrollElement === document.body
    ? window.innerHeight + window.scrollY
    : (scrollElement.scrollTop || 0) + (scrollElement.clientHeight || 0);
};
